import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import AOS from "aos";
import "aos/dist/aos.css";

const AOS_CONFIG = {
  duration: 1200,
  once: true,
};

export const AOSInit = () => {
  useEffect(() => {
    AOS.init(AOS_CONFIG);
  }, []);

  return null;
};

/**
 * Call this component inside a route layout (e.g. PagesRootLayout) so it has
 * access to useLocation. When the route changes, it runs AOS.refreshHard() so
 * newly mounted [data-aos] elements are discovered and animated instead of
 * staying at opacity 0.
 */
export const AOSRefresh = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (typeof AOS.refreshHard === 'function') {
        AOS.refreshHard();
      } else {
        AOS.refresh();
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}